import React from 'react';

import { Header } from 'formlabs-web-components/Type';

import ProductOptionCard from './ProductOptionCard';

import '../ProductDetailPlugin.module.css';

const OptionSection = ({
  title,
  subtitle,
  children,
  options,
  handleOptionChange
}) => {
  return (
    <div styleName="option-section">
      <Header level={3} displayAs={4} weight={700}>
        {title}
      </Header>

      <p styleName="option-subtitle">{subtitle}</p>
      {children}
      {options &&
        options.map(option => (
          <ProductOptionCard
            key={option.name}
            option={option}
            handleOptionChange={handleOptionChange}
          />
        ))}
    </div>
  );
};

export default OptionSection;
